const _UTILS = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);

    observer.observe(node, config);
    return observer;
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  },
};

document.addEventListener("alpine:init", () => {
  Alpine.data("HeaderNav", () => ({
    flags: {
      is_mobile: true,
      is_homepage: true,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      let am = this;
      am.$watch("flags.is_mobile", am.ToggleView.bind(am));
      document.addEventListener("headerStickyChange", am.ToggleView.bind(am));
    },
    InitSelf() {
      let am = this;
      am.flags.is_homepage = am.$el.dataset.ishomepage == "true";
      let mq = window.matchMedia("(max-width: 769px)");
      am.flags.is_mobile = mq.matches;
      mq.addEventListener("change", () => {
        am.flags.is_mobile = mq.matches;
      });
      am.ToggleView();
    },
    ToggleView() {
      let am = this;
      if (!am.flags.is_homepage) return;
      let $header = document.querySelector("#HeaderWrapper");
      if (am.flags.is_mobile) {
        $header.classList.toggle(
          "header-wrapper--overlay",
          !am.flags.is_mobile
        );
        $header.classList.toggle("is-light", !am.flags.is_mobile);
      } else {
        // $header.classList.toggle(
        //   "header-wrapper--overlay",
        //   window.scrollY == 0
        // );
        // $header.classList.toggle("is-light", window.scrollY == 0);
      }
    },
    e_OpenMobileNav(e) {
      // console.log(e)
      document.dispatchEvent(new CustomEvent("mobileNav:open"));
    },
  }));

  Alpine.data("MobileNav", () => ({
    e_ToggleAccordions(e) {
      let $mobile_nav = e.target.closest("mobile-nav");
      let target_link = e.target.closest("details").dataset.link;
      $mobile_nav.querySelectorAll("details").forEach(($detail) => {
        if ($detail.dataset.link != target_link) {
          $detail.removeAttribute("open");
        }
      });
    },
  }));

  Alpine.data("MenuAccordion", () => ({
    flags: {
      is_mobile: true,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      let am = this;
      am.$watch("flags.is_mobile", am.ToggleView.bind(am));
    },
    InitSelf() {
      let am = this;
      let mq = window.matchMedia("(max-width: 767px)");
      am.flags.is_mobile = mq.matches;
      mq.addEventListener("change", () => {
        am.flags.is_mobile = mq.matches;
      });
      am.ToggleView();
    },
    ToggleView() {
      let am = this;
      if (!am.flags.is_mobile) {
        am.$el.setAttribute("open", true);
      } else {
        am.$el.removeAttribute("open");
      }
    },
  }));

  Alpine.data("VideoMp4", () => ({
    flags: {
      paused: true,
    },
    autoplay: false,
    loop: false,
    cache: {},
    _playPromise: null,
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitEventHandlers();
    },
    safePlay() {
      let am = this;
      let video = am.cache.$video;
      if (!video) return;
      try {
        let playPromise = video.play();
        am._playPromise = playPromise;
        if (playPromise !== undefined && typeof playPromise.then === "function") {
          playPromise.then(
            function () {
              if (am._playPromise === playPromise) am._playPromise = null;
            },
            function () {
              /* Ignore AbortError when pause() interrupts play() */
              if (am._playPromise === playPromise) am._playPromise = null;
            }
          );
        }
      } catch (_) {}
    },
    safePause() {
      let am = this;
      let video = am.cache.$video;
      if (!video) return;
      let pauseNow = function () {
        try {
          video.pause();
        } catch (_) {}
      };
      if (am._playPromise && typeof am._playPromise.then === "function") {
        am._playPromise.then(pauseNow).catch(pauseNow);
        return;
      }
      pauseNow();
    },
    InitSelf() {
      let am = this;
      if (am.cache.$video.poster) {
        am.cache.$video.poster = am.cache.$video.poster.replace("_small", "");
      }
      if (am.autoplay) {
        am.safePlay();
        am.flags.paused = false;
      }
      if (!am.autoplay) {
        am.cache.$video.removeAttribute("muted");
      }
      if (am.loop) {
        am.cache.$video.loop = true;
      }
      if (am.autoplay) {
        _UTILS.ObserveIntersection(am.cache.$video, {}, (entries) => {
          let entry = entries[0];
          if (entry.isIntersecting) {
            am.safePlay();
          } else {
            am.safePause();
          }
        });
      }
    },
    InitCache() {
      let am = this;
      am.cache.$video = am.$el.querySelector("video");
      am.autoplay = am.$el.dataset.autoplay == "true";
      am.loop = am.$el.dataset.loop == "true";
    },
    InitEventHandlers() {
      let am = this;
      am.cache.$video.addEventListener("pause", () => {
        am.flags.paused = true;
      });
      am.cache.$video.addEventListener("play", () => {
        am.flags.paused = false;
      });
    },
    e_ToggleVideoPlay() {
      let am = this;
      am.flags.paused = !am.flags.paused;
      am.cache.$video.muted = false;
      if (am.flags.paused) {
        am.safePause();
      } else {
        am.safePlay();
      }
      am.cache.$video.controls = !am.flags.paused;
      if (am.cache.$video.closest("#custom-video-card")) {
        am.cache.$video
          .closest("#custom-video-card")
          .classList.toggle("active");
      }
    },
  }));

  Alpine.data("Swiper", () => ({
    swiper: null,
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      let sw_options = JSON.parse(am.$el.dataset.options);

      if (sw_options.centeredSlides) {
        let $slides = am.$el.querySelectorAll(".swiper-slide");
        if ($slides.length <= 3) {
          sw_options.initialSlide = 1;
        }
      }

      if (sw_options.pagination) {
        sw_options = Object.assign(sw_options, {
          pagination: {
            el: am.$el.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      }

      if (sw_options.navigation) {
        sw_options = Object.assign(sw_options, {
          navigation: {
            nextEl: am.$el.querySelector(".swiper-button-next"),
            prevEl: am.$el.querySelector(".swiper-button-prev"),
          },
        });
      }

      sw_options.breakpoints = {
        768: {
          slidesPerView: sw_options.slidesPerViewTab,
          centeredSlides: sw_options.centeredSlidesTab,
          initialSlide: sw_options.initialSlideTab,
          spaceBetween: sw_options.spaceBetweenTab,
          loop: sw_options.loop,
          autoplay: sw_options.autoplay,
          speed: sw_options.speed,
        },
        1024: {
          slidesPerView: sw_options.slidesPerViewDesk,
          centeredSlides: sw_options.centeredSlidesdesktop,
          spaceBetween: sw_options.spaceBetweenDesktop,
          loop: sw_options.loop,
        },
      };

      am.swiper = new Swiper(am.$el, sw_options);
    },
  }));

  Alpine.data("ProductMain", () => ({
    price: "",
    price_modifier: "",
    percent_saved: "",
    flags: {
      is_Onetime: false,
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      let am = this;
      am.$el.addEventListener("purchaseOption:changed", (e) => {
        // console.log(e);
        am.flags.is_Onetime = e.detail.is_Onetime;
        am.price = e.detail.price;
        am.price_modifier = e.detail.price_modifier;
        am.percent_saved = Math.floor((1 - am.price_modifier) * 100);
      });
    },
    GetPrice() {
      let am = this;
      return window.FormatMoney(am.price);
    },
    GetSubscriptionPrice() {
      let am = this;
      return window.FormatMoney(am.price * am.price_modifier);
    },
  }));

  Alpine.data("SubscriptionWidget", () => ({
    cache: {},
    price: "",
    price_modifier: "",
    subscribePrice: null,
    purchaseOption: "",
    selling_plan: "",
    variantId: "",
    planMap: {},
    flags: {
      is_Onetime: false,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.RemoveDefaultWidget();
      this.syncHeaderPrice();
    },
    destroy() {
      if (this._onVariantChange && this.cache.$product) {
        this.cache.$product.removeEventListener("brs:variant-price", this._onVariantChange);
      }
      if (this._onFormVariantChange && this.cache.$product_form) {
        this.cache.$product_form.removeEventListener("variant:change", this._onFormVariantChange);
      }
    },
    InitWatchers() {
      let am = this;
      am.$watch("purchaseOption", () => {
        am.flags.is_Onetime = am.purchaseOption == "one-time";
        let e_detail = {
          is_Onetime: am.flags.is_Onetime,
          price: am.price,
          price_modifier: am.price_modifier,
        };
        if (am.cache.$product) {
          am.cache.$product.dispatchEvent(
            new CustomEvent("purchaseOption:changed", { detail: e_detail })
          );
        }
        am.syncHeaderPrice();
        am.dispatchPurchaseType();
      });
      am.$watch("price", () => am.syncHeaderPrice());
      am.$watch("subscribePrice", () => am.syncHeaderPrice());
      am.$watch("selling_plan", () => am.syncHeaderPrice());
    },
    InitSelf() {
      let am = this;
      am.purchaseOption = am.$el.dataset.preSelect;
      am.price = Number(am.$el.dataset.price) || 0;
      am.price_modifier = Number(am.$el.dataset.priceModifier) || 1;
      am.flags.is_Onetime = am.purchaseOption == "one-time";
      am.selling_plan = am.$el.dataset.defaultSellingPlan || "";
      am.variantId = am.$el.dataset.variantId || "";

      am.cache.$product = am.$el.closest(".page-content--product");
      am.cache.$product_form =
        am.$el.closest(".shopify-product-form") ||
        am.$el.closest("form[data-type='add-to-cart-form']");

      am.planMap = am.loadPlanMap();
      am.applyVariantId(am.variantId || am.cache.$product_form?.querySelector('input[name="id"]')?.value);

      am._onFormVariantChange = (e) => {
        const variantId = Number(e.detail?.variantId);
        if (!Number.isFinite(variantId)) return;
        am.applyVariantId(variantId);
      };
      if (am.cache.$product_form) {
        am.cache.$product_form.addEventListener("variant:change", am._onFormVariantChange);
      }

      am._onVariantChange = (e) => {
        const variant = e.detail?.variant;
        if (!variant) return;
        if (
          e.detail?.productId &&
          String(e.detail.productId) !== String(am.$el.dataset.productId)
        ) {
          return;
        }
        am.applyVariantId(variant.id, variant);
      };
      if (am.cache.$product) {
        am.cache.$product.addEventListener("brs:variant-price", am._onVariantChange);
      }
    },
    loadPlanMap() {
      const am = this;
      // Prefer the JSON next to this widget (inside the form), then section-level.
      const jsonEl =
        am.$el.previousElementSibling?.matches?.("[data-brs-variant-selling-plans]")
          ? am.$el.previousElementSibling
          : am.cache.$product?.querySelector("[data-brs-variant-selling-plans]") ||
            am.$el.parentElement?.querySelector("[data-brs-variant-selling-plans]");
      if (!jsonEl?.textContent) return {};
      try {
        return JSON.parse(jsonEl.textContent) || {};
      } catch (err) {
        return {};
      }
    },
    applyVariantId(variantId, variantObj) {
      const am = this;
      if (variantId == null || variantId === "") return;
      const id = String(variantId);
      am.variantId = id;

      const entry = am.planMap[id];
      if (entry?.price != null) {
        am.price = Number(entry.price);
      } else if (variantObj?.price != null) {
        am.price = Number(variantObj.price);
      }

      const plans = entry?.plans || [];
      if (plans.length) {
        // Keep current plan if still valid for this variant; otherwise first allocation.
        const stillValid = plans.find((p) => String(p.id) === String(am.selling_plan));
        const next = stillValid || plans[0];
        am.selling_plan = String(next.id);
        am.subscribePrice = next.price != null ? Number(next.price) : null;
        if (next.compare_at_price != null) {
          am.price = Number(next.compare_at_price) || am.price;
        }
      } else {
        // Variant has no selling plans (e.g. Try Once) — force one-time.
        am.selling_plan = "";
        am.subscribePrice = null;
        if (am.purchaseOption === "subscription") {
          am.purchaseOption = "one-time";
          am.flags.is_Onetime = true;
        }
      }

      am.syncHeaderPrice();
      requestAnimationFrame(() => am.syncHeaderPrice());
      setTimeout(() => am.syncHeaderPrice(), 60);
    },
    GetPrice() {
      let am = this;
      return window.FormatMoney ? window.FormatMoney(am.price) : am.price;
    },
    GetSubscriptionPrice() {
      let am = this;
      if (am.subscribePrice != null) {
        return window.FormatMoney ? window.FormatMoney(am.subscribePrice) : am.subscribePrice;
      }
      const sub = Number(am.price) * Number(am.price_modifier);
      return window.FormatMoney ? window.FormatMoney(sub) : sub;
    },
    syncHeaderPrice() {
      const am = this;
      const root = am.cache.$product;
      if (!root) return;
      const main = root.querySelector(".product-main-price");
      const compare = root.querySelector(".product-compare-price");
      if (!main) return;

      if (am.flags.is_Onetime) {
        main.innerHTML = am.GetPrice();
        if (compare) {
          compare.innerHTML = "";
          compare.setAttribute("aria-hidden", "true");
        }
      } else {
        main.innerHTML = am.GetSubscriptionPrice();
        if (compare) {
          compare.innerHTML = am.GetPrice();
          compare.removeAttribute("aria-hidden");
        }
      }
    },
    dispatchPurchaseType() {
      const am = this;
      window.dispatchEvent(
        new CustomEvent("brocshot:purchase-type", {
          detail: {
            sectionId: am.$el.dataset.sectionId,
            productId: am.$el.dataset.productId,
            is_Onetime: am.flags.is_Onetime,
          },
        })
      );
    },
    RemoveDefaultWidget() {
      _UTILS.ObserveMutation(".shopify-product-form", {}, (m) => {
        m.filter(
          (m_item) =>
            m_item.addedNodes.length &&
            m_item.addedNodes[0].classList &&
            m_item.addedNodes[0].classList.contains("rc_container_wrapper")
        ).forEach((m_item) => {
          m_item.addedNodes[0].remove();
        });
      });
    },
    openLearnMore() {
      if (typeof window.openBrsSubLearnMoreModal === "function") {
        window.openBrsSubLearnMoreModal();
      }
    },
  }));

  // Single open tab + Alpine x-class on panels: used by brs--section-faq-with-image only
  // (brs--section-faq-with-video omits context: faq-w-image so each collapsible is independent).
  Alpine.data("FAQs_WithImage", () => ({
    current: "",
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.current = am.$el.dataset.current || "";
    },
    e_SetFaqCurrent(e, id) {
      let $button = e.target.closest(".collapsible-trigger");
      let am = this;
      am.current = id;
      if ($button.getAttribute("aria-expanded") == "false") {
        am.current = "";
      }

      let $section = $button.closest("[x-data]");
      $section.querySelectorAll("at-collapsible").forEach(($tab) => {
        let $btn = $tab.querySelector("button");
        let $collapsible = $tab.querySelector(".collapsible-content");
        let tab_id = $collapsible.id;
        if (am.current != tab_id) {
          $btn.classList.remove("is-open");
          $collapsible.classList.remove("is-open");
          $collapsible.style.height = "0px";
        }
      });
    },
  }));
});

  const cartConfig = (window.theme && window.theme.brocshotCart) || {};
  const disableRebuySmartCart = cartConfig.disableRebuySmartCart !== false;

  // Keep header cart badge count in sync on every add / remove / qty change.
  ;(function setupHeaderCartCountSync() {
    let fetchTimer = null;

    function applyHeaderCartCount(count) {
      count = parseInt(count, 10);
      if (Number.isNaN(count) || count < 0) count = 0;

      document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
        el.textContent = String(count);
      });

      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', count > 0);
      });

      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = String(count);
      });

      document.querySelectorAll('.brs-smart-cart__item-count').forEach((wrap) => {
        wrap.innerHTML =
          `(<span data-cart-count>${count}</span> ${count === 1 ? 'item' : 'items'})`;
      });

      const trigger = document.querySelector('#HeaderCartTrigger');
      if (trigger) {
        if (!trigger.dataset.cartLabelBase) {
          trigger.dataset.cartLabelBase = (trigger.getAttribute('aria-label') || 'Cart')
            .replace(/\s*\(\d+\)\s*$/, '')
            .trim();
        }
        const base = trigger.dataset.cartLabelBase || 'Cart';
        trigger.setAttribute('aria-label', count > 0 ? `${base} (${count})` : base);
      }
    }

    function refreshHeaderCartCountFromCartJs() {
      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(() => {
        fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((res) => (res.ok ? res.json() : null))
          .then((cart) => {
            if (cart && typeof cart.item_count === 'number') {
              applyHeaderCartCount(cart.item_count);
            }
          })
          .catch(() => {});
      }, 50);
    }

    document.addEventListener('cart:updated', (evt) => {
      const count = evt?.detail?.cart?.item_count;
      if (typeof count === 'number') {
        applyHeaderCartCount(count);
        return;
      }
      refreshHeaderCartCountFromCartJs();
    });

    ;[
      'ajaxProduct:added',
      'brocshot:rebuy-cart-changed',
      'brocshot:cart-markup-updated',
      'CartDrawer:open',
    ].forEach((name) => {
      document.addEventListener(name, refreshHeaderCartCountFromCartJs);
    });
  })();


  // Refresh the cart-drawer Rebuy widget after ATC / cart changes so it
  // hydrates when the drawer opens (widgets in closed drawers often stay empty).
  // Critical path: Add from the empty-cart Rebuy list must re-fetch so jar/shaker
  // rules replace the discovery products (same as main PDP ATC).
  ;(function setupCartRebuyWidgetRefresh() {
    const widgetId = () =>
      String(
        ((window.theme && window.theme.brocshotCart) || cartConfig || {}).rebuyCartWidgetId || ''
      ).trim();

    let lastItemCount = null;
    let refreshTimer = null;
    let retryTimer = null;
    let updatingLockTimer = null;
    // Hide Rebuy while empty-cart discovery → jar/shaker swap settles (avoids flash).
    let suppressRefresh = false;

    function findCartWidget() {
      const id = widgetId();
      if (!id || !window.Rebuy || !Array.isArray(window.Rebuy.widgets)) return null;
      return (
        window.Rebuy.widgets.find((w) => String(w.id) === id || String(w.data?.id) === id) || null
      );
    }

    function isCartDrawerWidget(widget) {
      const id = widgetId();
      if (!id || !widget) return false;
      return String(widget.id) === id || String(widget.data?.id) === id;
    }

    function getWidgetEls() {
      const id = widgetId();
      if (!id) return { el: null, wrap: null };
      const el = document.querySelector(`[data-rebuy-cart-widget][data-rebuy-id="${id}"]`);
      const wrap = el ? el.closest('.cart-recommendations--rebuy') : null;
      return { el, wrap };
    }

    function setRebuyUpdating(on) {
      suppressRefresh = !!on;
      const { el, wrap } = getWidgetEls();
      if (el) {
        if (on) el.setAttribute('data-rebuy-updating', 'true');
        else el.removeAttribute('data-rebuy-updating');
      }
      if (wrap) {
        if (on) wrap.setAttribute('data-rebuy-updating', 'true');
        else wrap.removeAttribute('data-rebuy-updating');
      }
      clearTimeout(updatingLockTimer);
      if (on) {
        // Never leave the widget permanently hidden.
        updatingLockTimer = setTimeout(() => setRebuyUpdating(false), 4500);
      }
    }

    function markRebuyHydrated() {
      const { el, wrap } = getWidgetEls();
      if (!el) return;
      const hasProducts = el.querySelectorAll('.rebuy-product-block, .rebuy-product').length > 0;
      if (hasProducts) {
        el.setAttribute('data-rebuy-hydrated', 'true');
        if (wrap) wrap.setAttribute('data-rebuy-hydrated', 'true');
      } else {
        el.removeAttribute('data-rebuy-hydrated');
        if (wrap) wrap.removeAttribute('data-rebuy-hydrated');
      }
    }

    function ensureWatchCart(widget) {
      if (!widget || widget.__brsWatchCart || typeof widget.watchCart !== 'function') return;
      widget.__brsWatchCart = true;
      try {
        widget.watchCart(() => {
          if (suppressRefresh) return;
          markRebuyHydrated();
        });
      } catch (_) {}
    }

    function syncRebuyCart(done) {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        if (typeof done === 'function') done();
      };
      const cart = window.Rebuy && window.Rebuy.Cart;
      if (!cart) {
        finish();
        return;
      }

      try {
        if (typeof cart.fetch === 'function') {
          const ret = cart.fetch(finish);
          if (ret && typeof ret.then === 'function') {
            ret.then(finish).catch(finish);
          }
          setTimeout(finish, 120);
          return;
        }
        if (typeof cart.get === 'function') {
          const ret = cart.get();
          if (ret && typeof ret.then === 'function') {
            ret.then(finish).catch(finish);
            return;
          }
        }
      } catch (_) {}
      finish();
    }

    function paintWidget(widget) {
      try {
        if (typeof widget.render === 'function') widget.render();
        if (typeof widget.show === 'function') widget.show();
      } catch (_) {}
      markRebuyHydrated();
    }

    function refreshCartRebuyWidget(options = {}) {
      const force = !!options.force;
      const reveal = !!options.reveal;
      if (suppressRefresh && !force) return;

      const { el } = getWidgetEls();
      if (!el) {
        if (reveal) setRebuyUpdating(false);
        return;
      }

      const widget = findCartWidget();
      if (!widget) {
        if (reveal) setRebuyUpdating(false);
        return;
      }

      ensureWatchCart(widget);

      syncRebuyCart(() => {
        try {
          const done = () => {
            paintWidget(widget);
            if (reveal) setRebuyUpdating(false);
          };
          if (typeof widget.getWidgetProducts === 'function') {
            widget.getWidgetProducts(done);
          } else {
            done();
          }
        } catch (_) {
          if (reveal) setRebuyUpdating(false);
        }
      });
    }

    function clearPendingRefreshTimers() {
      clearTimeout(refreshTimer);
      clearTimeout(retryTimer);
    }

    function scheduleCartRebuyRefresh(delay = 280) {
      if (suppressRefresh) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => refreshCartRebuyWidget(), delay);
    }

    function noteItemCount(count) {
      if (typeof count !== 'number') return;
      lastItemCount = count;
    }

    // Empty-cart Rebuy Add uses "Try Once". Remap to the 30 Servings sibling so
    // Rebuy's jar/shaker rules can match (same variant main CTA uses).
    function pickOnetimeServingVariant(variants, selected) {
      const list = variants || [];
      if (!list.length) return null;
      const selectedTitle = String(selected?.title || selected?.name || '');
      if (!/try\s*once/i.test(selectedTitle)) return null;
      return (
        list.find((v) => /30\s*servings?/i.test(String(v.title || v.name || ''))) ||
        list.find((v) => !/try\s*once/i.test(String(v.title || v.name || '')) && v.available !== false) ||
        null
      );
    }

    document.addEventListener('rebuy.beforeAdd', (event) => {
      const { product, widget } = event?.detail || {};
      if (!isCartDrawerWidget(widget) || !product) return;

      // Hide discovery list immediately so it can't flash beside jar/shaker.
      setRebuyUpdating(true);
      clearPendingRefreshTimers();

      const variants = product.variants || [];
      const selected =
        product.selected_variant ||
        variants.find((v) => String(v.id) === String(product.selected_variant_id)) ||
        variants.find((v) => v.is_selected);
      const replacement = pickOnetimeServingVariant(variants, selected);
      if (!replacement || String(replacement.id) === String(selected?.id)) return;

      product.selected_variant = replacement;
      product.selected_variant_id = replacement.id;
      if ('variant_id' in product) product.variant_id = replacement.id;
    });

    async function swapTryOnceLineForRebuyRules() {
      const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(
        /\/?$/,
        '/'
      );
      try {
        const cart = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then((r) => (r.ok ? r.json() : null));
        if (!cart || !Array.isArray(cart.items)) return false;

        const tryOnceLine = cart.items.find((item) =>
          /try\s*once/i.test(String(item.variant_title || item.title || ''))
        );
        if (!tryOnceLine || !tryOnceLine.handle) return false;

        const product = await fetch(`${root}products/${tryOnceLine.handle}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then((r) => (r.ok ? r.json() : null));
        if (!product) return false;

        const selected = (product.variants || []).find((v) => String(v.id) === String(tryOnceLine.variant_id));
        const replacement = pickOnetimeServingVariant(product.variants || [], selected || { title: 'Try Once' });
        if (!replacement || String(replacement.id) === String(tryOnceLine.variant_id)) return false;

        const qty = Number(tryOnceLine.quantity || 1);
        const changeRes = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: tryOnceLine.key, quantity: 0 }),
        });
        if (!changeRes.ok) return false;

        const mergeProps =
          typeof window.brocshotMergeBrocshotSubscriptionProperty === 'function'
            ? window.brocshotMergeBrocshotSubscriptionProperty
            : null;
        const lineProps = mergeProps
          ? mergeProps(tryOnceLine.properties, !!tryOnceLine.selling_plan_allocation?.selling_plan?.id)
          : tryOnceLine.properties || {};

        const addRes = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: replacement.id,
                quantity: qty,
                properties: lineProps,
              },
            ],
          }),
        });
        if (!addRes.ok) return false;

        document.dispatchEvent(
          new CustomEvent('brocshot:rebuy-cart-changed', { detail: { open: true } })
        );
        if (typeof window.brocshotScheduleSubscriptionCartSync === 'function') {
          window.brocshotScheduleSubscriptionCartSync();
        }
        return true;
      } catch (_) {
        return false;
      }
    }

    function finalizeEmptyCartWidgetAdd() {
      // One paint after cart is correct — no multi-retry flash of discovery + jar.
      refreshCartRebuyWidget({ force: true, reveal: true });
      clearTimeout(retryTimer);
      retryTimer = setTimeout(() => {
        const { el } = getWidgetEls();
        const hasProducts = !!(el && el.querySelectorAll('.rebuy-product-block, .rebuy-product').length);
        if (!hasProducts) {
          refreshCartRebuyWidget({ force: true, reveal: true });
        } else if (suppressRefresh) {
          setRebuyUpdating(false);
        }
      }, 650);
    }

    ;[
      'ajaxProduct:added',
      'CartDrawer:open',
      'cart:open',
      'brocshot:rebuy-cart-changed',
      'brocshot:cart-markup-updated',
      'rebuy.loaded',
    ].forEach((name) => {
      document.addEventListener(name, () => scheduleCartRebuyRefresh());
    });

    // Add from the cart-drawer Rebuy widget (empty-cart product list).
    document.addEventListener('rebuy.add', (event) => {
      if (!isCartDrawerWidget(event?.detail?.widget)) return;
      setRebuyUpdating(true);
      clearPendingRefreshTimers();
      void swapTryOnceLineForRebuyRules().finally(() => {
        finalizeEmptyCartWidgetAdd();
      });
    });

    document.addEventListener('rebuy:cart.add', () => {
      scheduleCartRebuyRefresh(320);
    });

    document.addEventListener('rebuy:cart.change', (event) => {
      const shopifyCart = event?.detail?.cart?.cart || event?.detail?.cart;
      noteItemCount(shopifyCart?.item_count);
      scheduleCartRebuyRefresh(320);
    });

    document.addEventListener('rebuy.ready', (event) => {
      if (isCartDrawerWidget(event?.detail?.widget)) {
        ensureWatchCart(event.detail.widget);
      }
    });

    document.addEventListener('rebuy.productsChange', (event) => {
      if (!isCartDrawerWidget(event?.detail?.widget)) return;
      // While settling empty-cart → jar, ignore interim discovery re-renders.
      if (suppressRefresh) return;
      markRebuyHydrated();
    });

    if (window.Rebuy && Array.isArray(window.Rebuy.widgets)) {
      scheduleCartRebuyRefresh(50);
    }
  })();

  // Rebuy hydrates the cart on page load and can emit show/change events.
  // Only auto-open the native drawer after a real add-to-cart (or cart icon click).
  let allowCartAutoOpen = false;
  const armCartAutoOpen = () => {
    allowCartAutoOpen = true;
    clearTimeout(armCartAutoOpen._timer);
    armCartAutoOpen._timer = setTimeout(() => {
      allowCartAutoOpen = false;
    }, 5000);
  };

  const armCartOpenGrace = (ms = 800) => {
    window.__brsCartLockOpen = true;
    clearTimeout(window.__brsCartLockTimer);
    window.__brsCartLockTimer = setTimeout(() => {
      window.__brsCartLockOpen = false;
    }, ms);
  };

  const reassertNativeCartDrawer = () => {
    const drawer = document.querySelector("#HeaderCart");
    if (!drawer) return;
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    drawer.classList.add("is-active");
    drawer.setAttribute("data-user-opened", "true");
    document.documentElement.classList.add("cart-open");
  };

  // Ignore outside-clicks while the page is still loading, and for a short
  // moment after it finishes. The close button still works.
  const ignoreAccidentalCartClose = () => {
    if (window.__brsCartUserDismissed) return false;
    if (window.__brsCartLockOpen) return true;
    if (!window.__brsCartHoldOpen) return false;
    if (document.readyState !== "complete") return true;
    if (!window.__brsCartLoadSettledAt || Date.now() - window.__brsCartLoadSettledAt < 800) return true;
    return false;
  };

  const markCartDismissedByUser = () => {
    window.__brsCartUserDismissed = true;
    window.__brsCartHoldOpen = false;
    window.__brsCartLockOpen = false;
    clearTimeout(window.__brsCartLockTimer);
  };

  const forceShowNativeCartDrawer = () => {
    window.__brsCartHoldOpen = true;
    window.__brsCartUserDismissed = false;
    reassertNativeCartDrawer();
    // Lock briefly so ATC / modal click-through cannot slam it shut
    armCartOpenGrace(800);
  };

  const openNativeCartDrawer = () => {
    forceShowNativeCartDrawer();
    document.dispatchEvent(new CustomEvent("cart:open"));
  };

  // While the page is still loading, re-assert open state if anything strips it
  // (Rebuy hydrate, header re-init, modal scripts, etc.)
  ;(function keepCartOpenDuringBoot() {
    let ticks = 0;
    const timer = setInterval(() => {
      ticks += 1;
      if (document.readyState === "complete" && !window.__brsCartLoadSettledAt) {
        window.__brsCartLoadSettledAt = Date.now();
      }
      const pageSettled =
        window.__brsCartLoadSettledAt && Date.now() - window.__brsCartLoadSettledAt > 800;
      // If add-to-cart opened the drawer while the page was still loading,
      // put the open class back when something else strips it. Do not reset
      // the close-button lock — the X must still close the drawer.
      if (window.__brsCartHoldOpen && !window.__brsCartUserDismissed && !pageSettled) {
        const drawer = document.querySelector("#HeaderCart");
        if (drawer && !drawer.classList.contains("is-active")) {
          reassertNativeCartDrawer();
        }
      }
      if (pageSettled || ticks > 120) {
        clearInterval(timer);
        // Keep any active ATC grace timer; only clear a stale boot lock
        if (!window.__brsCartLockTimer) {
          window.__brsCartLockOpen = false;
        }
      }
    }, 100);
  })();

  const suppressRebuySmartCart = () => {
    if (!disableRebuySmartCart) return;
    document.documentElement.classList.add("rebuy-smart-cart-disabled");

    if (!window.Rebuy || !window.Rebuy.SmartCart) return;

    const smartCart = window.Rebuy.SmartCart;

    // Stop Smart Cart from auto-opening on ATC (Rebuy API)
    try {
      smartCart.skip_open = true;
    } catch (e) {}

    if (typeof smartCart.hide === "function") {
      try {
        smartCart.hide();
      } catch (e) {}
    }

    // Any Smart Cart open attempt → native drawer only (when armed by ATC)
    if (typeof smartCart.show === "function" && !smartCart.__brocshotPatched) {
      smartCart.show = function () {
        try {
          if (typeof smartCart.hide === "function") smartCart.hide();
        } catch (e) {}
        if (allowCartAutoOpen) openNativeCartDrawer();
      };
      smartCart.__brocshotPatched = true;
    }
  };

  // Early cart-icon handler so clicks during page load don't navigate away / race-close
  document.addEventListener(
    "click",
    (evt) => {
      const trigger = evt.target.closest && evt.target.closest("#HeaderCartTrigger");
      if (!trigger) return;
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      const drawer = document.querySelector("#HeaderCart");
      const isOpen =
        window.__brsCartLockOpen ||
        document.documentElement.classList.contains("cart-open") ||
        (drawer && drawer.classList.contains("is-active"));

      if (isOpen) {
        // Toggle close only on explicit second cart-icon click
        allowCartAutoOpen = false;
        window.__brsCartSuppressAutoOpenUntil = Date.now() + 1500;
        markCartDismissedByUser();
        if (drawer) {
          drawer.classList.remove("is-active");
          drawer.removeAttribute("data-user-opened");
        }
        document.documentElement.classList.remove("cart-open");
        document.querySelectorAll(".brs-cart-backdrop").forEach((el) => el.remove());
        document.dispatchEvent(new CustomEvent("cart:close"));
        return;
      }

      openNativeCartDrawer();
    },
    true
  );

  function headerCartModuleReady() {
    return window.__brsHeaderCartReady === true;
  }

  function forceCloseNativeCartDrawer(explicit) {
    if (!explicit && ignoreAccidentalCartClose()) {
      reassertNativeCartDrawer();
      return;
    }
    allowCartAutoOpen = false;
    window.__brsCartSuppressAutoOpenUntil = Date.now() + 1500;
    markCartDismissedByUser();
    const drawer = document.querySelector("#HeaderCart");
    if (drawer) {
      drawer.classList.remove("is-active");
      drawer.removeAttribute("data-user-opened");
    }
    document.documentElement.classList.remove("cart-open");
    document.querySelectorAll(".brs-cart-backdrop").forEach((el) => el.remove());
  }

  function formatDrawerMoney(cents, format) {
    const amount = (Number(cents) / 100).toFixed(2);
    const parts = amount.split(".");
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formatted = dollars + "." + parts[1];
    if (format && format.indexOf("{{") !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
    }
    return "$" + formatted;
  }

  function cartAjaxRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  let drawerFillToken = 0;
  let drawerFillTimer = null;

  // Header cart module never starts when its cart helper import fails to load.
  // PDP and landing pages share this drawer, so both open an empty shell
  // with no close handler until this fallback fills it.
  function scheduleFillDrawer() {
    clearTimeout(drawerFillTimer);
    drawerFillTimer = setTimeout(fillDrawerFromAjaxCart, 200);
  }

  function fillDrawerFromAjaxCart() {
    if (headerCartModuleReady()) return;
    const products = document.querySelector("#HeaderCart [data-products]");
    if (!products) return;

    const token = ++drawerFillToken;
    const root = cartAjaxRoot();
    fetch(`${root}cart?view=ajax&t=${Date.now()}`.replace(/([^:]\/)\/+/g, "$1"), {
      credentials: "same-origin",
    })
      .then((res) => (res.ok ? res.text() : ""))
      .then((text) => {
        if (!text || token !== drawerFillToken || headerCartModuleReady()) return;
        const html = document.createElement("div");
        html.innerHTML = text;
        const items = html.querySelector(".cart__items");
        if (!items) return;
        products.replaceChildren(items);

        const count = parseInt(items.getAttribute("data-count"), 10) || 0;
        const animate = products.closest(".site-header__drawer-animate");
        if (animate) animate.classList.toggle("is-empty", count === 0);

        const subtotalEl = document.querySelector("#HeaderCart [data-subtotal]");
        const form = document.querySelector("#HeaderCart form");
        if (subtotalEl) {
          subtotalEl.innerHTML = formatDrawerMoney(
            items.getAttribute("data-cart-subtotal"),
            form && form.dataset.moneyFormat
          );
        }

        document.querySelectorAll("#HeaderCart [data-cart-count]").forEach((el) => {
          el.textContent = String(count);
        });
        document.querySelectorAll("#HeaderCart .brs-smart-cart__item-count").forEach((wrap) => {
          wrap.innerHTML =
            '(<span data-cart-count>' + count + "</span> " + (count === 1 ? "item" : "items") + ")";
        });
      })
      .catch(() => {});
  }

  function changeDrawerLine(key, qty) {
    if (headerCartModuleReady() || !key) return;
    const root = cartAjaxRoot();
    fetch(`${root}cart/change.js`.replace(/([^:]\/)\/+/g, "$1"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(qty) }),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === "number") {
          document.querySelectorAll("[data-cart-count]").forEach((el) => {
            el.textContent = String(cart.item_count);
          });
        }
        fillDrawerFromAjaxCart();
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      })
      .catch(() => {});
  }

  document.addEventListener("cart:quantity", (evt) => {
    if (headerCartModuleReady()) return;
    const detail = evt.detail || [];
    if (!detail[0]) return;
    changeDrawerLine(detail[0], detail[1]);
  });

  document.addEventListener(
    "click",
    (evt) => {
      const closeBtn =
        evt.target.closest && evt.target.closest("#HeaderCart .js-close-header-cart");
      if (closeBtn) {
        allowCartAutoOpen = false;
        window.__brsCartSuppressAutoOpenUntil = Date.now() + 1500;
        markCartDismissedByUser();
        if (headerCartModuleReady()) return;
        evt.preventDefault();
        forceCloseNativeCartDrawer(true);
        return;
      }

      if (!headerCartModuleReady()) {
        const removeBtn =
          evt.target.closest && evt.target.closest("#HeaderCart .cart__item-remove-btn");
        if (removeBtn) {
          evt.preventDefault();
          const item = removeBtn.closest(".cart__item");
          changeDrawerLine(item && item.dataset.key, 0);
          return;
        }
      }

      if (headerCartModuleReady()) return;
      if (!document.documentElement.classList.contains("cart-open")) return;
      if (ignoreAccidentalCartClose()) return;
      if (evt.target.closest && evt.target.closest("#HeaderCart, #HeaderCartTrigger")) return;
      forceCloseNativeCartDrawer(false);
    },
    true
  );

  document.addEventListener("keyup", (evt) => {
    if (evt.key !== "Escape" || headerCartModuleReady()) return;
    if (!document.documentElement.classList.contains("cart-open")) return;
    forceCloseNativeCartDrawer(true);
  });

  // Open native drawer as soon as ATC succeeds — do not wait for Rebuy
  document.addEventListener("ajaxProduct:added", () => {
    armCartAutoOpen();
    openNativeCartDrawer();
    scheduleFillDrawer();
  });

  // Run early + on Rebuy ready (class is also set in theme.liquid for CSS)
  suppressRebuySmartCart();
  document.addEventListener("rebuy:cart.show", () => {
    suppressRebuySmartCart();
    if (window.__brsCartSuppressAutoOpenUntil && Date.now() < window.__brsCartSuppressAutoOpenUntil) return;
    // Ignore Rebuy's page-load / hydrate show — only open after ATC armed the flag
    if (allowCartAutoOpen) openNativeCartDrawer();
  });

  document.addEventListener("cart:open", () => {
    scheduleFillDrawer();
  });
  document.addEventListener("cart:build", () => {
    scheduleFillDrawer();
  });

  // Keep trying to patch Smart Cart until Rebuy arrives (don't block drawer open)
  let rebuyPatchAttempts = 0;
  const rebuyPatchTimer = setInterval(() => {
    rebuyPatchAttempts += 1;
    suppressRebuySmartCart();
    if ((window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.__brocshotPatched) || rebuyPatchAttempts > 40) {
      clearInterval(rebuyPatchTimer);
    }
  }, 250);

  document.addEventListener("rebuy.loaded", (event) => {
    let $header = document.querySelector("#HeaderWrapper");
    if ($header && !$header.getAttribute("x-data")) {
      $header.setAttribute("x-data", "HeaderNav");
    }

    suppressRebuySmartCart();
    clearInterval(rebuyPatchTimer);

    // Refresh line items without opening the drawer on hydrate/change.
    // Only open when Rebuy reports an add.
    const refreshNativeCart = (shouldOpen) => {
      document.dispatchEvent(
        new CustomEvent("brocshot:rebuy-cart-changed", {
          detail: { open: !!shouldOpen },
        })
      );
    };
    document.addEventListener("rebuy:cart.change", () => refreshNativeCart(false));
    ["rebuy:cart.add", "rebuy.add", "rebuy.product.add"].forEach((name) => {
      document.addEventListener(name, () => {
        armCartAutoOpen();
        refreshNativeCart(true);
      });
    });

    const closeMenu = document.querySelector(".desktop-close-menu");
    if (closeMenu) {
      closeMenu.addEventListener("click", () => {
        document.dispatchEvent(new CustomEvent("mobileNav:close"));
      });
    }
  });
